import React from 'react';
import { Shield, Code2, Cloud, ChevronRight } from 'lucide-react';
import { expertise } from '../data/mock';

const iconMap = {
  Shield: Shield,
  Code2: Code2,
  Cloud: Cloud
};

const ExpertiseSection = () => {
  return (
    <section id="expertise" className="py-24 bg-zinc-900/30">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-cyan-400 font-mono text-sm mb-2">// EXPERTISE</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white">What I Do</h2>
        </div>

        {/* Expertise Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {expertise.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="group p-8 bg-zinc-950 border border-zinc-800 rounded-2xl hover:border-cyan-500/50 transition-all duration-300 hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-cyan-500/10 border border-cyan-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:bg-cyan-500/20 transition-colors">
                  <IconComponent className="w-7 h-7 text-cyan-400" />
                </div>

                {/* Title & Description */}
                <h3 className="text-xl font-semibold text-white mb-3">
                  {item.title}
                </h3>
                <p className="text-zinc-400 text-sm mb-6">
                  {item.description}
                </p>

                {/* Skills List */}
                <ul className="space-y-3">
                  {item.skills.map((skill, skillIndex) => (
                    <li
                      key={skillIndex}
                      className="flex items-start gap-3 text-sm text-zinc-500 group-hover:text-zinc-400 transition-colors"
                    >
                      <ChevronRight className="w-4 h-4 text-cyan-500 flex-shrink-0 mt-0.5" />
                      <span>{skill}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
